// This is where we connect out sanity client with our react app
import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: true,
  token: process.env.REACT_APP_SANITY_TOKEN,
});

// This is the code we always write when we working with images in sanity
const builder = imageUrlBuilder(client);
export const urlFor = (source) => builder.image(source);
